<footer class="footer">
	<div class="footer-copyright text-center">
		@{{ year }} Sushi Izu. All rights reserved.
	</div>
</footer>